//平台预收款常量定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 来源
 */
class Source extends UltMeta {
    MEMBER_RECHARGE = new Meta(1, "会员充值");
    OWNER_SHIP_INFO_SERVICE_FEE = new Meta(2, "货主船务信息服务费");
    CAPTAIN_SHIP_INFO_SERVICE_FEE = new Meta(3, "船主船务信息服务费");
}

export const SOURCE = new Source();
